import { loadGroups } from "@/store/flow/actions";
import { defineComponent } from "vue";

export default defineComponent({
  name: "sdk-flow-candidate-groups",
  props: {
    closeAction: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      checkList: [] as string[],
      candidateGroups: [] as string[],
    };
  },
  computed: {
    candidateGroupsString(): string {
      return this.checkList.join();
    },
  },
  methods: {
    applyCandidateGroups() {
      document.body.dispatchEvent(
        new CustomEvent("candidateGroups:selected", {
          bubbles: true,
          detail: { ids: this.candidateGroupsString },
        })
      );
      this.closeAction();
    },
  },
  async mounted() {
    const candidateGroups: any = await document.querySelector('[name="candidateGroups"]');
    const candidateGroupsValue = candidateGroups && candidateGroups.value !== "" ? candidateGroups.value.split(",") : [];
    this.checkList = candidateGroupsValue;
    this.candidateGroups = await this.$dispatch(loadGroups)();
  },
});
